import { ISessionManager } from 'common/sessions';
import { GqlClient } from 'GqlClient';
import { ITracker } from './ITracker';
import { MockTracker } from './MockTracker';
import { ServerTracker } from './ServerTracker';

export const createTracker = ({
  browserTrackerId,
  client,
  isBot,
  sessionManager,
}: {
  browserTrackerId: string;
  client: GqlClient;
  isBot: boolean;
  sessionManager: ISessionManager;
}): ITracker => {
  if (isBot) {
    return new MockTracker();
  }

  return new ServerTracker({ browserTrackerId, client, sessionManager });
};
